import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_sfmertj2fk: FaireBrandEntity = {
  token: "b_sfmertj2fk",
  type: "brand",
  name: "Organifi",
  avatarUrl:
    "https://cdn.faire.com/fastly/d7cb348302f82c2763209c798ce3a74c40181d89d419e4d0fe974f17b85c9516.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4218dcaf1f601080110d502f594a8b9c287604ed9237dc08feb5855f63d255db.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d7cb348302f82c2763209c798ce3a74c40181d89d419e4d0fe974f17b85c9516.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4218dcaf1f601080110d502f594a8b9c287604ed9237dc08feb5855f63d255db.png",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 28,
  isInsider: true,
  description:
    "Our story began with wanting to make a healthy lifestyle easier for everyone. We noticed a lot of “quick solves” and empty health promises that left people frustrated and feeling hopeless. After discovering the healing powers of superfoods, we knew we finally found a way to make healthy living easy, fun, and delicious.\n\nThe delicious part was the problem we had to solve. as we set out to develop a more convenient superfood blend, we were told that a healthy green juice couldn’t taste good. we challenged that idea and after 52 iterations, we proudly introduced Organifi green juice to the world. a superfood blend that tasted amazing and made it easier for anyone to choose their own health every day.\n\nToday Organifi’s top-quality blends are SHARED ACROSS THE GLOBE. We started with a simple idea to make nutrition easy and delicious for everyone. This turned into a mission to unite the world through community, wholeness, and habit transformation. WE’RE IN THIS TOGETHER AND WE’RE JUST GETTING STARTED.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:27.926Z",
    importedBy: "entity-db-cli",
  },
};
